module.exports = __webpack_public_path__ + "img/yml_gallery6.82a221e0.jpg";